<template>
    <apexchart :options="chartOptions" :series="series" type="donut"/>
</template>

<script>
    export default {
        name: "WidgetChart3",
        data() {
            return {
                chartOptions: {
                    chart: {
                        id: 'vuechart-example3',
                        toolbar: {
                            show: false
                        },
                    },
                    plotOptions: {
                        pie: {
                            donut: {
                                size: '55%'
                            }
                        }
                    },
                    title: {
                        text: "Статистика по всем статусам"
                    },
                    legend: {
                        position: 'bottom',
                        horizontalAlign: 'left',
                        fontSize: '10px',
                    },
                    labels: ["зарегистрирован", "отклонено", "передан начальнику участка", "передан мастеру ПУ", "готов к открытию", "открыт"],
                },
                series: [32, 6, 8, 4, 5, 5],

            }
        },
    }
</script>

<style scoped>

</style>